import { render, staticRenderFns } from "./DeleteArea.vue?vue&type=template&id=25662e55&scoped=true"
import script from "./DeleteArea.vue?vue&type=script&lang=js"
export * from "./DeleteArea.vue?vue&type=script&lang=js"
import style0 from "./DeleteArea.vue?vue&type=style&index=0&id=25662e55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25662e55",
  null
  
)

export default component.exports